<div class="modal">
    <div class="body">
        <div class="header">
            <div class="title" translate>MODAL_COOKIE_PREFERENCE_TITLE</div>
            <div class="description">{{ 'MODAL_COOKIE_PREFERENCE_DESCRIPTION' | translate }} <a class="cta-link" target="_blank"
                    href="{{ 'MODAL_COOKIE_PREFERENCE_DESCRIPTION_LINK_ABOUT' | translate }}">{{ 'MODAL_COOKIE_PREFERENCE_DESCRIPTION_ABOUT' |
                    translate
                    }}</a></div>
        </div>
        <form [formGroup]="cookiesConsentConfigurationForm" [appConnectForm]="(cookiesConsentConfiguration$ | async)">
            <div formGroupName="groups">
                <div class="categories-section">
                    <div class="categories-header">
                        <h3 class="title-section">{{'MODAL_COOKIE_CATEGORIES_TITLE' | translate}}</h3>
                        <div class="tick">
                            <app-smash-switch-on-off [value]="allCookiesToggled" (valueChange)="onToggleAllCategories($event)">
                            </app-smash-switch-on-off>
                        </div>
                    </div>
                </div>
                <div class="section">
                    <h3 class="title-section" translate>MODAL_COOKIE_PREFERENCE_REQUIRED_TITLE</h3>
                    <div class="section-row form-section">
                        <p class="description align-left" translate>MODAL_COOKIE_PREFERENCE_REQUIRED_DESCRIPTION</p>
                        <div class="tick">
                            <app-smash-switch-on-off [disabled]="true" [value]="true"></app-smash-switch-on-off>
                        </div>
                    </div>
                </div>
                <div class="section" formGroupName="analytics">
                    <h3 class="title-section" translate>MODAL_COOKIE_ANALYTICS_TITLE</h3>
                    <div class="section-row form-section">
                        <p class="description align-left" translate>MODAL_COOKIE_ANALYTICS_DESCRIPTION</p>
                        <div class="tick">
                            <app-smash-switch-on-off [disabled]="true" formControlName="enabled"></app-smash-switch-on-off>
                        </div>
                    </div>
                </div>
                <div class="section" formGroupName="marketing">
                    <h3 class="title-section" translate>MODAL_COOKIE_MARKETING_TITLE</h3>
                    <div class="section-row form-section">
                        <p class="description align-left" translate>MODAL_COOKIE_MARKETING_DESCRIPTION</p>
                        <div class="tick">
                            <app-smash-switch-on-off formControlName="enabled"></app-smash-switch-on-off>
                        </div>
                    </div>
                </div>
                <div class="section" formGroupName="social">
                    <h3 class="title-section" translate>MODAL_COOKIE_SOCIAL_MEDIA_AND_ADVERTISING_TITLE</h3>
                    <div class="section-row form-section">
                        <p class="description align-left" translate>MODAL_COOKIE_SOCIAL_MEDIA_AND_ADVERTISING_DESCRIPTION</p>
                        <div class="tick">
                            <app-smash-switch-on-off formControlName="enabled"></app-smash-switch-on-off>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <div class="footer">
        <button *ngIf="ref?.data?.cancelable" class="btn-new white" (click)="close()" translate>MODAL_COOKIE_PREFERENCE_CANCEL</button>
        <button class="btn-new red" (click)="save()" translate>MODAL_COOKIE_PREFERENCE_SAVE</button>
    </div>
</div>